export default {

    environment: process.env.VUE_APP_NODE_ENV,

    sentry: {

        sentryRealease: process.env.VUE_APP_SENTRY_RELEASE,

        sentryUrl: 'https://14656254b288433b9099a4fd5596bc07@sentry.io/1370826'

    },

    url: {

        baseUrl: process.env.VUE_APP_BASE_URL,
        server: process.env.VUE_APP_SERVER_URL
    },

    front: {
        minimalAge: process.env.VUE_APP_MINIMAL_AGE,
        abTestingMaxDuration: process.env.VUE_APP_AB_TIMEOUT || 2000
    },

    email: {
        contact: 'support@cleanfox.io'
    },

    size: {
        tablet: 568,
        desktop: 800
    },

    tracking: {
        gtagId: process.env.VUE_APP_GTAG_ID,
        optimizeId: process.env.VUE_APP_OPTIMIZE_ID,
        amplitudeKey: process.env.VUE_APP_AMPLITUDE_KEY
    },

    languages: [ 'en', 'fr', 'de', 'es', 'it' ],

    defaultLanguage: 'en',

    firebaseConfig: {
        apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
        authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
        projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGIN_SENDER_ID,
        appId: process.env.VUE_APP_FIREBASE_APP_ID,
        measurementId: process.env.VUE_APP_FIREBASE_MEASURMENT_ID,
        cloudMessagingCertificat: process.env.VUE_APP_CERTIFICATS_WEB_PUSH
    },

    indexedDb: {
        name: 'cleanfox',
        version: 1
    }
}
